export const home = {
  seo: {
    title: 'Bistroo - Logiciel de commande pour restaurants & restauration',
    description: "Le logiciel de commande (marque blanche) le plus abordable et flexible pour les restaurants. Gérez les commandes en ligne, conservez vos données clients et renforcez votre propre marque.",
  },
  hero: {
    pill: {
      label: 'We simply serve',
      text: 'Restaurants',
    },

    heading: {
      title: 'Vos clients commandent via votre propre',
      words: ['boutique en ligne', 'site web', 'caisse', 'borne', 'QR code'],
    },

    saving_time: 'Nous vous faisons gagner du temps et augmentons vos bénéfices.',
    boosting_business: 'Nous boostons votre activité en ligne.',

    header_mockup_alt: 'Tableau de bord & Page d\'accueil',
    partners_alt: 'Approuvé par nos partenaires',
  },
  landing_pages: {
    heading: {
      create: 'Créez',
      your_restaurant: 'un site web ou une boutique en ligne',
      shop_in_minutes: 'pour votre restaurant en quelques minutes',
    },

    personalized_webshop:
      'Une boutique en ligne et un site web personnalisés pour votre restaurant, en ligne en un rien de temps.',
    start_free: 'Démarrez gratuitement aujourd\'hui et choisissez parmi plus de 1000 designs personnalisables.',

    actions: {
      create_your_website: 'Créer votre site web',
    },
  },
  key_features: {
    pill: {
      label: 'Fonctionnalités clés',
      text: 'Tout ce que vous devez savoir',
    },

    heading: 'Tout ce dont vous avez besoin pour les commandes en ligne',

    personalize_order_experience:
      'Personnalisez l\'expérience de commande de vos clients avec notre système de commande en ligne',
    boost_sales:
      'entièrement personnalisable. Découvrez les outils pour faire croître votre restaurant tout en réduisant vos coûts.',

    cards: {
      order_management_with_ease: {
        title: 'Gestion des commandes simplifiée.',
        text: 'Offrez à vos clients une expérience de commande personnalisée avec notre gestionnaire de boutique en ligne entièrement configurable.',
        button: 'Voir le Manager',
      },
      plug_and_play: {
        title: 'Plug-and-play.',
        text: 'Démarrez en quelques minutes avec notre Bistroo Device ou utilisez votre propre téléphone ou ordinateur portable.',
      },
      peak_times: {
        title: 'Gérez les heures de pointe.',
        text: 'Ajustez les paramètres en temps réel.',
      },
      instant_payments: {
        title: 'Paiements instantanés.',
        text: 'Encaissez vos commandes à tout moment.',
        img_alt: 'POS portable',
      },
      many_more: {
        title: 'Et bien plus encore !',
        text: 'Voulez-vous plus de détails sur les meilleures fonctionnalités ?',
        button: 'Voir toutes les fonctionnalités',
      },
    },
  },
  paragraphs: {
    paragraph_1: {
      title: 'La Caisse quick-service de Bistroo entièrement intégrée',
      text: 'Pas d\'installations complexes ni de configuration compliquée comme avec les systèmes de caisse traditionnels. À partir de seulement 15 € par mois, vous avez accès à un système de caisse moderne conçu pour les restaurants de service rapide. Pas de contrats à long terme, pas de frais cachés.',
      cta: 'Voir la Caisse',
    },
    paragraph_2: {
      title: 'Options de commande en magasin prêtes pour le plug-and-play',
      text: 'Permettez aux clients de commander et payer facilement via des QR codes et des bornes libre-service. Réduisez les files d\'attente, augmentez la valeur des commandes et servez plus de clients sans pression supplémentaire sur votre personnel. Nous constatons généralement un service plus rapide et un chiffre d\'affaires plus élevé au restaurant.',
      cta: 'Voir le Kiosk',
      cta_2: 'Voir le QR',
    },
    paragraph_3: {
      title: 'Le seul service entièrement autogéré',
      text: 'La dernière chose que vous souhaitez en tant que propriétaire de restaurant ou de boutique alimentaire, c\'est devoir appeler quelqu\'un pour modifier votre menu. Nous vous donnons le contrôle total sur vos données, produits, clients et commandes !',
      cta: 'Voir le Manager',
    },
  },
  products: {
    pill: {
      label: 'Produits Bistroo',
      text: 'Tout ce que nous offrons',
    },
    heading: 'Choisissez les solutions qui s\'intègrent parfaitement dans la recette de votre entreprise',
    stop_overspending:
      'Arrêtez de trop payer pour des logiciels coûteux remplis de fonctionnalités inutilisées, réduisez vos coûts et augmentez votre efficacité.',
    productivity_increase:
      'Nous constatons en moyenne une augmentation de 20 % de la productivité et du chiffre d\'affaires lors d\'une utilisation optimale de nos solutions.',
    start_for_free: 'Démarrer gratuitement maintenant',

    cards: {
      bistroo: 'Bistroo',
      webshop: {
        title: 'Webshop',
        img_alt: 'Bistroo Webshop',
        action: 'Voir Webshop',
      },
      page: {
        title: 'Website',
        img_alt: 'Bistroo Page',
        action: 'Voir Page',
      },
      qr: {
        title: 'QR',
        img_alt: 'Bistroo QR',
        action: 'Voir QR',
      },
      pos: {
        title: 'Caisse',
        img_alt: 'Bistroo Caisse',
        action: 'Voir Caisse',
      },
      posdevice: {
        title: 'Device',
        img_alt: 'Bistroo Device',
        action: 'Voir Device',
      },
      kiosk: {
        title: 'Kiosk',
        img_alt: 'Bistroo Kiosk',
        action: 'Voir Kiosk',
      },
      manager: {
        title: 'Manager',
        img_alt: 'Bistroo Manager',
        action: 'Voir Manager',
      },
    },
  },
  integrations: {
    heading: 'Utilisez des intégrations plug-and-play',
    text: 'Gérez et optimisez les commandes en ligne grâce aux intégrations avec vos outils et systèmes de caisse préférés. Nous avons tout préparé, connectez simplement ce dont vous avez besoin ! C\'est aussi simple que cela.',
    action: 'Voir les intégrations',
  },
  testimonials: {
    pill: {
      label: 'Témoignages clients',
      text: 'Ce que disent les entrepreneurs',
    },

    heading: 'Ces entrepreneurs utilisent déjà Bistroo et disent..',
    empowered_our_clients: 'Découvrez comment nos solutions ont apporté le succès aux entrepreneurs !',

    testimonials: {
      hero: {
        img_alt: 'Mondie Scheepers - Two-B by Mondie',
        text: '"Bistroo nous fait gagner beaucoup de temps chaque jour et réduit la frustration chez nos clients, et nous constatons également une augmentation des commandes à emporter."',
        author: 'Mondie Scheepers',
        company: 'Two-B by Mondie',
        action: 'Lire l\'histoire complète',
      },

      reviews: {
        one: {
          text: '"Depuis que nous sommes passés à Bistroo, nous n\'avons plus à prendre de commandes par téléphone, ce qui nous fait gagner un temps précieux et nous donne plus de place pour le service à nos clients."',
          author: 'Roberta',
          company_role: 'Hôtesse, Il Municipio',
          action: 'Lire l\'histoire',
        },
        two: {
          text: '"Avec Bistroo, nous économisons facilement plus de 250 euros par mois. De plus, grâce à la promotion, nous avons vu plus de clients arriver via Bistroo. C\'est avantageux pour nous car ces commandes sont bien moins chères en termes de coûts."',
          author: 'Hamza',
          company_role: 'Propriétaire, Grillroom Istanbul',
          action: 'Lire l\'histoire',
        },
        three: {
          text: '"Grâce à Bistroo, nous avons plus de contrôle sur les moments chargés. Auparavant, les commandes téléphoniques n\'étaient parfois pas prises, ce qui pouvait entraîner une perte de chiffre d\'affaires. Nous le voyons clairement dans nos chiffres."',
          author: 'Henk Boom',
          company_role: "Propriétaire, cafetaria D'n Boom",
          action: 'Lire l\'histoire',
        },
      },
    },
  },
}
